import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function fetchMyInvoisTypes(){
    const myInvoisTypeResponse = await axios.get(`government/config/myinvois/invoisType/get`, { withCredentials : true, });
    return myInvoisTypeResponse?.data;
}

async function fetchMyInvoisConfigPark(park_id){
    const myInvoisConfigParkResponse = await axios?.get(`government/config/myinvois/park/${park_id}/get`, { withCredentials : true, });
    return myInvoisConfigParkResponse?.data;
}

export default {
    fetchMyInvoisTypes,
    fetchMyInvoisConfigPark,
}